var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temTexto
    ? _c(
        "div",
        { staticClass: "ai-generated-note" },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center az-gap-xsmall mb-1" },
            [
              _c("icon-svg", { attrs: { name: "stars", size: 16 } }),
              _c("span", { staticClass: "text-sm font-medium" }, [
                _vm._v(_vm._s(_vm.rotulo))
              ])
            ],
            1
          ),
          _c("p", { staticClass: "text-sm text-color-900 mb-0" }, [
            _vm._v(" " + _vm._s(_vm.textoVisivel) + " "),
            _vm.precisaTruncar
              ? _c(
                  "button",
                  {
                    staticClass:
                      "ai-generated-note__toggle text-xs text-color-600",
                    attrs: { type: "button" },
                    on: { click: _vm.alternar }
                  },
                  [_vm._v(" " + _vm._s(_vm.toggleLabel))]
                )
              : _vm._e()
          ]),
          _vm._t("rodape")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }